import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Interface for TikTok tracking queue
interface TikTokQueue {
  page: () => void;
  track: (event: string, data?: any) => void;
  [key: string]: any;
}

// Declare global TikTok tracking object
declare global {
  interface Window {
    ttq?: TikTokQueue;
  }
}

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Log page navigation for debugging
    console.log('Page navigation:', location.pathname);
    
    // Track page view with TikTok Pixel
    if (window.ttq) {
      try {
        // Send page view event to TikTok
        window.ttq.page();
        console.log('TikTok page view tracked:', location.pathname);
      } catch (error) {
        console.error('TikTok tracking error:', error);
      }
    }
  }, [location.pathname, location.search]);
}; 